import { useEffect, useState } from "react";
import Modal from "../../../components/modal";

const SalesBillVariantPosModel = ({ show, onClose, addCart, heading, initialData = [], cart = [] }) => {

console.log('product', cart);
  const [mode, setMode] = useState("size");
  const [activeTab, setActiveTab] = useState(null);

  const [searchTerm, setSearchTerm] = useState("");
  const [dateRange, setDateRange] = useState({ start: "", end: "" });
  const [filteredSalesData, setFilteredSalesData] = useState([]);

  useEffect(() => {
    if (mode === "size" && initialData?.sizes?.length > 0) {
      setActiveTab(initialData?.sizes[0].size);
    }
    if (mode === "color" && initialData?.colors?.length > 0) {
      setActiveTab(initialData?.colors[0].color);
    }
  }, [mode, initialData]);

  const buildStockMatrix = () => {
    const sizes = initialData.sizes?.map(s => s.size) || [];
    const colors = initialData.colors || [];

    const rows = colors.map(colorObj => {
      const row = {
        color: colorObj.color,
        total: 0
      };

      sizes.forEach(size => {
        const qty = colorObj.data.filter(
          item => item.variant_name?.startsWith(size + "-")
        ).length;

        row[size] = qty;
        row.total += qty;
      });

      return row;
    });

    const columnTotals = {};
    sizes.forEach(size => {
      columnTotals[size] = rows.reduce((sum, r) => sum + (r[size] || 0), 0);
    });

    const grandTotal = rows.reduce((sum, r) => sum + r.total, 0);

    return { sizes, rows, columnTotals, grandTotal };
  };


  const isSerialInCart = (serial_no) => {
    return cart?.some(s => s.serial_no === serial_no);
  };

  const handleToggleCart = ({ product, variant_id, serial_no, remove }) => {
    console.log('handleToggleCart', { product, variant_id, serial_no, remove });
    addCart({ product, variant_id, serial_no, remove });
  };

  const filteredVariations = () => {
    if (mode === "size") {
      return initialData?.sizes?.find(s => s.size === activeTab)?.data || [];
    }
    if (mode === "color") {
      return initialData?.colors?.find(c => c.color === activeTab)?.data || [];
    }
    return [];
  };

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString("en-IN");
  };



  return (
    <Modal show={show} onClose={onClose} heading={heading} size="lg">
      <div className="row">

        {/* Left Side Options */}
        <div className="col-3 border-end">
          <div
            className={`p-2 mb-2 cursor-pointer ${mode === "size" && "bg-primary text-white"}`}
            onClick={() => setMode("size")}
          >
            Size
          </div>
          <div
            className={`p-2 mb-2 cursor-pointer ${mode === "color" && "bg-primary text-white"}`}
            onClick={() => setMode("color")}
          >
            Color
          </div>
          
        </div>

        {/* Right Side */}
        <div className="col-9">

          {/* Size/Color Tabs */}
          {mode !== "sales" && mode !== 'stock' && (
            <div className="mb-3 d-flex gap-2 flex-wrap">
              {mode === "size" && initialData?.sizes?.map((s, i) => (
                <button
                  key={i}
                  className={`btn ${activeTab === s.size ? "btn-primary" : "btn-outline-primary"}`}
                  onClick={() => setActiveTab(s.size)}
                >
                  Size: {s.size} (Qty:  {s.data.length ?? 0})
                </button>
              ))}

              {mode === "color" && initialData?.colors?.map((c, i) => (
                <button
                  key={i}
                  className={`btn ${activeTab === c.color ? "btn-primary" : "btn-outline-primary"}`}
                  onClick={() => setActiveTab(c.color)}
                >
                  Color: {c.color} (Qty: {c.data.length ?? 0})
                </button>
              ))}
            </div>
          )}

          {/* Serial Buttons (Size/Color Mode) */}
          {mode !== "sales" && mode !== 'stock' && (
            <div className="row">
              {filteredVariations().map((data, index) => {
                const selected = isSerialInCart(data.serial_no);
                return (
                  <div className="col-3 mb-3" key={index}>
                    <button
                      className={`btn w-100 ${selected ? 'btn-danger' : 'btn-success'} text-white fs-18`}
                      onClick={() => handleToggleCart({
                        product: data,
                        variant_id: data.id_variation,
                        serial_no: data.serial_no,
                        remove: selected
                      })}
                    >
                      {data.serial_no}
                    </button>
                  </div>
                );
              })}
            </div>
          )}

        </div>
      </div>
    </Modal>
  );
};

export default SalesBillVariantPosModel;
